import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { CameraSlash, X } from "@phosphor-icons/react";

export default function QrScanner({ onScan, onClose }) {
  const [error, setError] = useState("");
  const onScanRef = useRef(onScan);
  onScanRef.current = onScan;

  useEffect(() => {
    const scanner = new Html5Qrcode("venue-qr-reader");
    let active = true;
    let started = false;

    const start = async () => {
      try {
        const cameras = await Html5Qrcode.getCameras();
        if (!active) return;
        if (!cameras || cameras.length === 0) {
          setError("No camera detected");
          return;
        }
        const camera = cameras.find((c) => /back|rear|environment/i.test(c.label)) || cameras[0];
        if (!camera) throw new Error("No camera found on this device");
        await scanner.start(
          camera.id,
          { fps: 10, qrbox: { width: 240, height: 240 } },
          (decoded) => {
            if (!active) return;
            active = false;
            onScanRef.current(decoded);
          },
          () => {}
        );
        started = true;
      } catch (e) {
        if (active) setError(e?.message || "Camera access was blocked");
      }
    };
    start();

    return () => {
      active = false;
      try {
        if (started) {
          const p = scanner.stop();
          if (p && typeof p.catch === "function") p.catch(() => {});
        }
        const p2 = scanner.clear();
        if (p2 && typeof p2.catch === "function") p2.catch(() => {});
      } catch (_) {
        /* html5-qrcode may throw synchronously if not started */
      }
    };
  }, []);

  return (
    <div className="rounded-2xl border border-neon-violet/30 bg-black/70 p-3" data-testid="camera-scanner">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-[11px] font-bold uppercase tracking-widest text-neon-violet">Camera Scanner</span>
        <button type="button" data-testid="camera-close-btn" onClick={onClose}
          className="rounded-full border border-white/10 p-1.5 text-zinc-400 hover:text-white">
          <X size={14} />
        </button>
      </div>
      <div id="venue-qr-reader" className="overflow-hidden rounded-xl [&_video]:!w-full [&_video]:rounded-xl" />
      {error && (
        <div className="mt-3 flex items-center gap-2 rounded-xl border border-neon-yellow/30 bg-neon-yellow/5 px-3 py-2 text-xs font-bold text-neon-yellow" data-testid="camera-error">
          <CameraSlash size={15} /> {error}. You can still paste the code below.
        </div>
      )}
    </div>
  );
}
